import type { FC, ReactNode } from 'react'

interface FernMarkProps {
    className?: string
}

export const FernMark: FC<FernMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='4.5 1.5 23 30'
            className={className}
            aria-hidden='true'
            focusable='false'
        >
            <path
                d='M15 30 C12 24 10 18 10 11 A8 8 0 0 1 26 11 A6 6 0 0 1 14 11 A4 4 0 0 1 22 11 A2.5 2.5 0 0 1 17 11'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path d='M11.4 20.9 C8.5 20.6 6.6 18.6 6 15.8 C8.8 16.2 10.8 18 11.4 20.9 Z' fill='currentColor' />
            <path d='M12.95 25.5 C15.8 25.2 18 23.4 19 20.8 C16.2 21 13.9 22.8 12.95 25.5 Z' fill='currentColor' />
        </svg>
    )
}
